import React, { memo } from "react";
import { SafeAreaView } from "react-native-safe-area-context";

import { Box } from "@/components/atoms/Box";
import { Button } from "@/components/atoms/Button";

/**
 *
 */
interface ButtonSubmitProps {
  loading: boolean;
  isValid: boolean;
  onSubmit: () => void;
  isSmallScreen: boolean;
}

/**
 * Pure view component for note submission button with loading state
 * @param root0 - Component props
 * @param root0.loading - Whether note submission is in progress
 * @param root0.isValid - Whether form validation has passed
 * @param root0.onSubmit - Handler function called when submit button is pressed
 * @param root0.isSmallScreen - Whether device has small screen size
 */
const ButtonSubmitView = ({
  loading,
  isValid,
  onSubmit,
  isSmallScreen,
}: ButtonSubmitProps) => (
  <SafeAreaView edges={["bottom"]}>
    <Box className="p-4">
      <Button
        isDisabled={loading || !isValid}
        onPress={onSubmit}
        className="h-14 bg-surface-action"
        size="lg"
        label={!loading ? "Submit" : "Please Wait..."}
        labelTone={!loading && isValid ? "info" : "muted"}
        labelVariant={isSmallScreen ? "title-sm" : "title"}
      />
    </Box>
  </SafeAreaView>
);

ButtonSubmitView.displayName = "ButtonSubmitView";

export default memo(ButtonSubmitView);
